import axios from "axios";
import { INQUIRIES_URL } from "../utils";

export const fetchInquiries = () => {
  return axios.get(INQUIRIES_URL);
};
